import WithLoadable from 'components/WithLoadable';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default WithLoadable(() => import(/* webpackChunkName: "console" */ './index'));
